import LegalPage from "../../components/legal/LegalPage";
import document from "../../content/legal/terms-and-conditions.json";

export default function Page() {
  return <LegalPage title="Terms and Conditions" document={document} />;
}
